<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>管理者ログイン</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="email"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                    @keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import { VueReCaptcha } from 'vue-recaptcha-v3'

  // For more options see below
  Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY })

  export default {
    props: {
      source: String,
    },
    data () {
      return {
        email: undefined,
        password: undefined,
      }
    },
    methods: {
      async recaptcha() {
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded()

        // Execute reCAPTCHA with action "login".
        const token = await this.$recaptcha('login')

        // Do stuff with the received token.
        console.log(`token: ${token}`)
      },
      login () {
        if (this.email == 'masayuki.okubo.jp@gmail.com') {
          this.recaptcha()
          this.$fb.signInWithEmailAndPassword(this.$fb.auth, this.email, this.password)
          .then(() => {
            this.$router.push('main')
          })
          .catch(error => {
            console.error(error)
          })
        }
      }
    }
  }
</script>